import { BaseWindowViewScope } from '../base/BaseWindowViewScope';
import { SecondScopeInfo } from '../../scope/SecondScopeInfo';
import { SettlementService } from '../../service/SettlementService';
import { SettlementContractRequest } from '../../service/service-models/settlement/SettlementContractRequest';
import { PaymentInfo } from '../../service/models/payment/payment-info';
import { ErrorInfo } from '../../models/ErrorInfo';


/**
 * PayPay決済完了後ビュー情報
 */
export class PaymentErrorComponentView extends BaseWindowViewScope<SecondScopeInfo> {
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('paypayerr');
	}
	// --------------------------------------------------------------------------
		
	// サービス  -----------------------------------------------------------------
	private m_SettlementService: SettlementService = new SettlementService(); // 締結サービス
	// --------------------------------------------------------------------------
		
	// override メソッド  --------------------------------------------------------
	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		this.setGlobalScopeModel('location', '/step5_personal-information');
		const orderId: string = this.FW.getUrlParam('orderId');
		const vResultCode: string = this.FW.getUrlParam('vResultCode');
		const mstatus: string = this.FW.getUrlParam('mstatus');
		const paypayOrderId: string = this.FW.getUrlParam('paypayOrderId');
		const req: SettlementContractRequest = new SettlementContractRequest();
		req.paymentInfo = new PaymentInfo();
		req.paymentInfo.orderId = orderId;
		req.paypayCustTxn = paypayOrderId;
		req.paypayVResCode = vResultCode;
		req.paypayMStatus = mstatus;
		// 履歴登録は待つ必要なし
		this.m_SettlementService.addErrorHistory(this, req, (result) => {
			this.setGlobalScopeModel('AuthMailId', result.authMailId);
		});
		this.refreshView();
		const errInfo = new ErrorInfo();
		errInfo.message = 'PayPay決済に失敗したため、保険契約の手続きを行うことができませんでした。';
		this.setGlobalScopeModel('ErrorInfo', errInfo);
		this.pushPath('/error');
	}
	// --------------------------------------------------------------------------
}
